import { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAdminUsersQuery, useCountryDetailByIdQuery } from 'api';
import { ManagementRoleMapping, ManagerModel } from 'models/Manager';

export const useManagement = () => {
  const [modalState, setModalState] = useState<boolean>(false);
  const { id } = useParams() as { id: string };
  const { data: countryDetails = {} } = useCountryDetailByIdQuery({ id });
  const { data: userData = [] } = useAdminUsersQuery();

  const onAddModalStateChange = useCallback(() => setModalState((prevState) => !prevState), []);

  const managementData = useMemo(() => {
    const management: Record<string, ManagerModel> = {};
    userData.forEach((user: ManagerModel) => {
      management[user.id] = user;
    });
    return [
      {
        role: ManagementRoleMapping.salesManager,
        data: management[countryDetails.salesManagerId],
      },
      {
        role: ManagementRoleMapping.salesManagerAssistant,
        data: management[countryDetails.salesManagerAssistantId],
      },
      {
        role: ManagementRoleMapping.purchaseManager,
        data: management[countryDetails.purchaseManagerId],
      },
      {
        role: ManagementRoleMapping.purchaseManagerAssistant,
        data: management[countryDetails.purchaseManagerAssistantId],
      },
      {
        role: ManagementRoleMapping.postSalesManager,
        data: management[countryDetails.postSalesManagerId],
      },
      {
        role: ManagementRoleMapping.postSalesManagerAssistant,
        data: management[countryDetails.postSalesManagerAssistantId],
      },
    ];
  }, [userData, countryDetails]);

  return {
    modalState,
    onAddModalStateChange,
    countryDetails,
    managementData,
  };
};
